(function($) {
    /**
     * Add aria labels
     */
    $('#site-navigation').attr('aria-label', 'Main');
    $('.page-search nav.pagination').attr('aria-label', 'Search Results Pagination');

    /**
     * Set an active class on form field focus
     */
    $(document).on('focus','.ginput_container > input, .ginput_container > select, .ginput_container > textarea', function(){
        $(this).closest('.gfield').addClass("active");
    }).on('blur','.ginput_container > input, .ginput_container > select, .ginput_container > textarea', function(){
        $(this).closest('.gfield').removeClass("active");
    });

    /**
     * Add padding to the body of the page if the cookie bar is active
     * This prevents the cookie bar from overlapping the footer
     */
    var cookiebarPadding = function() {
        var $cookiebar = $('#cookie-law-info-bar');

        if ($cookiebar.length) {
            if ($cookiebar.css('display') == 'block') {
                $cookiebar_height = $cookiebar.outerHeight();
                $('body').css('padding-bottom', $cookiebar_height);
                return;
            }
        }

        $('body').css('padding-bottom', 0);
    }

    $(window).on('resize', cookiebarPadding);
    cookiebarPadding();

    var observer = new MutationObserver(function(mutations) {
        cookiebarPadding();
    });

    var target = document.querySelector('#cookie-law-info-bar');
    if (target) {
        observer.observe(target, {
            attributes: true
        });
    }

    /**
     * Add key listeners to the cookiebar dismiss link
     */
    var triggerCookiebarDismiss = function( e ) {
        
        if(e.which == 13) {
            e.preventDefault();
            e.stopPropagation();
            $('#cookie_action_close_header').trigger('click');
        }

        if(e.which == 32) {
            e.preventDefault();
            e.stopPropagation();
            $('#cookie_action_close_header').trigger('click');
        }
    }

    $(document).on('keyup', '#cookie_action_close_header', triggerCookiebarDismiss );

    document.addEventListener("DOMContentLoaded", function () {
        const videoIcon = document.querySelector(".home-hero-v2__video-icon");
        const videoPopup = document.querySelector(".video-popup");
        const videoPlayer = document.getElementById("videoPlayer");
        const body = document.querySelector("body");
        if(videoIcon) {
            videoIcon.addEventListener("click", function () {
                videoPopup.style.display = "block";
                videoPlayer.play();
                body.style.overflow = "hidden";
            });

            videoPopup.addEventListener("click", function (event) {
                if (event.target === videoPopup) {
                    videoPopup.style.display = "none";
                    videoPlayer.pause();
                    body.style.overflow = "auto";
                }
            });
        }
    });

    // limit the block under to above 1023px
    if ($(window).width() > 1023) {

        $('.insights-link').hover(function() {
            $('.insights-menu').addClass('active');
        });

        $('.insights-menu').hover(function() {
            $('.insights-menu').addClass('active');
        }, function() {
            $('.insights-menu').removeClass('active');
        }
        );

        $('.training-link').hover(function() {
            $('.training-menu').addClass('active');
        });

        $('.training-menu').hover(function() {
            $('.training-menu').addClass('active');
        }, function() {
            $('.training-menu').removeClass('active');
        }
        );
    }
})(jQuery);